module.exports = __webpack_public_path__ + "static/paper-lion-a4328954a733711bdccdf9ef804c08ac.jpg";